"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DegreeAndCertificateService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class DegreeAndCertificateService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.RESOURCE = 'students/degreeCertificate';
        // COMMON
        this.getStatusDegreeAndCertificate = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/status?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getStudentsDegreeAndCertificate = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCampusCatalogue = async (params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/catalogue/campus?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getCatalogueDynamic = async (ou, table) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/catalogue/${ou}/${table}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postStatusStudents = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/status`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postReportMet = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/export/reportMet`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getStudentProfilePic = async (pidm) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/profilePic/${pidm}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postCatalogueDynamic = async (ou, table, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/catalogue/${ou}/${table}`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postStudentSequence = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getStudentPercent = async (body) => {
            const queryString = this.objectToQueryString(Object.assign({}, body));
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/percent?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //CERTIFICATE
        this.getStudentsCertificateDetails = async (id, params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/certificate/details/${id}?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postMoviteScore = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/certificate/details/${id}/motiveScore`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.updateStudentKardexDetails = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/certificate/details/${id}`;
            const response = await axios_1.default.patch(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postStudentCertificateDetails = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/certificate/details/`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getStudentCertficateDetailsRequi = async (id, body) => {
            const queryString = this.objectToQueryString(Object.assign({}, body));
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/certificate/details/${id}/requirements?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //DEGREE
        this.getStudentDegreeDetails = async (id, params) => {
            const queryString = this.objectToQueryString(Object.assign({}, params));
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/degree/details/${id}?${queryString}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postStudentsDegreeDetails = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/degree/details`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.updateStudentDegreeDetails = async (id, body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/degree/details/${id}`;
            const response = await axios_1.default.patch(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.objectToQueryString = (obj) => Object.keys(obj).map(key => {
            const value = obj[key];
            let parameter = `${key}=${value}`;
            if (Array.isArray(value)) {
                let multiValueParams = '';
                const lastIndex = value.length - 1;
                value.forEach((item, index) => multiValueParams += `${key}=${item}${index === lastIndex ? '' : '&'}`);
                return multiValueParams;
            }
            return parameter;
        }).join("&");
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.DegreeAndCertificateService = DegreeAndCertificateService;
